var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('span',[_vm._v(" 🦋 蝴蝶影视平台   /   BUTTERFLY PICTURES"),_c('br'),_c('span',[_vm._v(_vm._s(_vm.t("footer1")))])]),_c('span',[_c('span',[_vm._v(_vm._s(_vm.t("footer2")))]),_c('br'),_c('span',[_vm._v(_vm._s(_vm.t("footer3")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }